import { render, staticRenderFns } from "./approval-travel-info.vue?vue&type=template&id=0dd6273c&scoped=true"
import script from "./approval-travel-info.vue?vue&type=script&lang=js"
export * from "./approval-travel-info.vue?vue&type=script&lang=js"
import style0 from "./approval-travel-info.vue?vue&type=style&index=0&id=0dd6273c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd6273c",
  null
  
)

export default component.exports